import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  setLayerVisible
} from '@actions/layers-actions';

import { createNewDataDetail } from '@actions/data-detail-actions';
import { toggleTraffic, toggleBicycle, toggleTransit } from '@actions/map-actions';

import LoadingIndicator from '@components/details/loading-indicator';
import Map from '@components/entity/info/map';
import Drawer from '@components/public/drawer';
import TopBar from '@components/public/top-bar';

import './details.scss';

const PublicDetails = () => {
  const dispatch = useDispatch();
  const { dataType } = useParams();
  const { details } = useSelector(state => state.config);
  const { data } = useSelector(state => state.dataDetail);

  useEffect(() => {
    dispatch(createNewDataDetail(dataType, true));
  }, [dispatch, dataType]);

  const mapTools = useMemo(
    () => details?.[dataType]?.form?.default_map_tools?.public,
    [details, dataType]
  );

  useEffect(() => {
    // Toggle entity specific map tools upon first load.
    if (mapTools?.length > 0) {
      if (mapTools.includes('bicycle')) {
        dispatch(toggleBicycle());
      }
      if (mapTools.includes('traffic')) {
        dispatch(toggleTraffic());
      }
      if (mapTools.includes('transit')) {
        dispatch(toggleTransit());
      }
    }
    dispatch(setLayerVisible('parking_meters', true));
  }, [dispatch, mapTools]);

  return (
    <div styleName="public-details-container">
      <LoadingIndicator />
      <div styleName="public-details-top-bar">
        <TopBar />
      </div>
      <div styleName="public-details-body">
        {data && <Drawer />}
        <Map publicMap />
      </div>
    </div>
  );
};

export default memo(PublicDetails);
